// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__n5np5","HeroImg":"Hero_HeroImg__R51oy","HeroText":"Hero_HeroText__rgZxl","HeroButtons":"Hero_HeroButtons__WZeK-","HeroImgMobile":"Hero_HeroImgMobile__xlRON"};